export default __webpack_public_path__ + "static/media/google-g-logo.12c8c6a1.svg";